module.exports = __webpack_public_path__ + "img/uv.1218cdf1.png";